// extracted by css-extract-rspack-plugin
export default {"hidden":"hidden--zQvzRI4s9Yss_6gY","xs":"xs--quJiiB_mowyBUoRZ","s":"s--KvamembDHasuW_K8","m":"m--dwUAzHYYW8ILoCTa","l":"l--dofkdKozM9oEslcK"};